module.exports = __webpack_public_path__ + "static/media/sign.641029e5.png";